


































































































































import { Vue, Component, Watch, Ref } from 'vue-property-decorator'
import paymentStore from '@/modules/payment/payment.store'
import { getModule } from 'vuex-module-decorators'
import AppButton from '@/modules/shared/components/AppButton/AppButton.vue'
import { PaymentAPI } from '@/api/payment'
import lottie from 'lottie-web'
import PayPalButton from '@/modules/payment/components/PayPalButton'
import { CancellationToken } from '@/utils/cancel'
import checkTransactionStatus from '@/utils/checkTransactionStatus'

@Component({
  components: { AppButton, PayPalButton }
})
export default class TournamentEntryFeePaymentDialog extends Vue {
  paymentModule = getModule(paymentStore, this.$store)

  isLoading: boolean = false
  step = 0
  currentWalletTransactionId: string = ''
  checkTransactionStatusCancellationToken: CancellationToken = new CancellationToken()

  @Ref('checkLottieAnimation')
  checkLottieAnimation!: HTMLDivElement

  @Watch('visible')
  onVisibilityChanged() {
    this.step = 0
  }

  mounted() {
    this.onVisibilityChanged()
  }

  beforeDestroy() {
    this.checkTransactionStatusCancellationToken.cancel()
  }

  async createOrder(paymentMethod: string) {
    console.log('[PAYMENT] Creating order.')
    this.isLoading = true

    const res = await this.paymentCallbacks!.createOrder(paymentMethod)
    console.log('[PAYMENT] Order created.', res)

    this.currentWalletTransactionId = res.walletTransactionId
    return res.orderId
  }

  async onApprove(orderId: string) {
    this.isLoading = true

    console.log(
      '[PAYMENT] User approved. Completing deposit.',
      this.currentWalletTransactionId
    )
    await PaymentAPI.completeDeposit(this.currentWalletTransactionId)

    if (this.paymentCallbacks!.onApprove) {
      await this.paymentCallbacks!.onApprove(orderId)
    }
  }

  async onComplete() {
    console.log('[PAYMENT] Completed. Checking status.')

    try {
      if (
        !(await checkTransactionStatus(
          this.currentWalletTransactionId,
          this.checkTransactionStatusCancellationToken
        ))
      )
        throw new Error('CheckTransactionStatus is failure')
    } catch (err) {
      console.log('[PAYMENT] Long polling failed!', err)
      this.onError(err)
      return
    }

    this.step = 2
    this.isLoading = false

    setTimeout(() => {
      const anim = lottie.loadAnimation({
        container: this.checkLottieAnimation,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: require('@/assets/lottie/5785-checkmark.json')
      })
      anim.setSpeed(0.5)
    })

    console.log('[PAYMENT] Completed!')
  }

  onError(err: Error) {
    console.log('[PAYMENT] Error!', err)
    this.step = 1
    this.isLoading = false

    this.checkTransactionStatusCancellationToken.cancel()
    this.checkTransactionStatusCancellationToken = new CancellationToken()

    if (this.paymentCallbacks!.onError) {
      this.paymentCallbacks!.onError(err)
    }
  }

  async onCancel() {
    console.log('[PAYMENT] Cancelled.')
    await PaymentAPI.cancelDeposit(this.currentWalletTransactionId)

    this.isLoading = false
  }

  onUserCancel() {
    this.paymentModule.closeTournamentEntryFeePaymentDialog()

    if (this.paymentCallbacks!.onCancel) {
      this.paymentCallbacks!.onCancel(this.currentWalletTransactionId)
    }
  }

  onUserComplete() {
    this.paymentModule.closeTournamentEntryFeePaymentDialog()

    if (this.paymentCallbacks!.onComplete) {
      this.paymentCallbacks!.onComplete(this.currentWalletTransactionId)
    }
  }

  get visible() {
    return this.paymentModule.isTournamentEntryFeePaymentDialogVisible
  }

  get fee() {
    return this.paymentModule.tournamentEntryFee
  }

  get currency() {
    return this.fee.substring(0, 3)
  }

  get paymentCallbacks() {
    return this.paymentModule.paymentCallbacks
  }

  get createPayPalOrder() {
    return this.createOrder.bind(this, 'PayPal')
  }
}
